/**
 * Real KittyPot app screenshots used across the marketing site.
 *
 * These are genuine product screens — do not restyle or recreate the app UI in
 * markup. Alt text describes what each screen actually shows.
 */

export type AppScreen = {
  src: string
  alt: string
}

export const screens = {
  kittyMain: {
    src: 'https://cdn.magicpatterns.com/uploads/c4Kerucv1xb9G1AxTbzzDX/Kitty_main.jpg',
    alt: 'KittyPot app showing the Ski Trip kitty with €2,393.82 total spent, eight members, and controls to add an expense or a receipt',
  },
  myBalance: {
    src: 'https://cdn.magicpatterns.com/uploads/ruK9x8wD3SgKf1WJz3TB1V/My_balance_screen.jpg',
    alt: 'KittyPot My Balance screen showing £2,137.37 owed across four kitties, listed one by one',
  },
  webJoin: {
    src: 'https://cdn.magicpatterns.com/uploads/u1NEfuQwBAqSzkBEnQ79m7/Web_join.jpg',
    alt: 'A phone browser at join.kittypot.com showing an invitation to the Weekend away kitty and a list of names to choose from',
  },
  createKitty: {
    src: 'https://cdn.magicpatterns.com/uploads/cAQ2PMqJZ8T4hUZTvJ74ZS/Create_Kitty.jpg',
    alt: 'KittyPot Name Kitty screen with the name Weekend away, GBP selected as the kitty currency, six members and an option to add people by name',
  },
  shareQr: {
    src: 'https://cdn.magicpatterns.com/uploads/8neQYeWRTcF8N5cN2bH3VB/sdfdsfge.jpg',
    alt: 'KittyPot share screen showing the Weekend away kitty with the join reference TQN5-RTMY and a QR code',
  },
  breakdown: {
    src: 'https://cdn.magicpatterns.com/uploads/9jbBDyZaBmHKEzxTwfnaik/Breakdown.jpg',
    alt: 'KittyPot Breakdown screen showing Will owes you €99.22, itemised by food, ski pass, drinks and accommodation, with Send nudge, Share bank details and Mark as paid buttons',
  },
  paymentRequest: {
    src: 'https://cdn.magicpatterns.com/uploads/7aYtHwyP1mA6yGxMYE1Zbd/zxczc.jpg',
    alt: 'A messaging app showing a KittyPot payment request from Bobby to Will for €99.22, with an itemised breakdown and bank details to pay outside KittyPot',
  },
  spinner: {
    src: 'https://cdn.magicpatterns.com/uploads/eQFmFwkDRaM5U67B8HEVdV/rtgrt.jpg',
    alt: "KittyPot's Whose round is next? screen showing a colourful spinning wheel with six names on it",
  },
  history: {
    src: 'https://cdn.magicpatterns.com/uploads/8DXYxyAQXvtMRrjik22MBF/Expense_History.jpg',
    alt: 'KittyPot Settlement history showing £803.00 total spent and four recorded expenses with who paid each one',
  },
} satisfies Record<string, AppScreen>
